// @need-translate
import {openWindow} from '../common/openWindow.function';
import {CashChargeCode} from '../domain/buy/cash/type';
import {CashChargeInfo} from '../logging/CashChargeInfo.interface';
import {currentEventContext} from '../logging/variables';

export function openCashCharge({
  returnUrl = '',
  chargeAmount,
  cashChargeInfo,
}: {
  returnUrl?: string;
  chargeAmount?: number;
  cashChargeInfo?: CashChargeInfo;
}) {
  currentEventContext.cashChargeInfo = cashChargeInfo;
  openWindow({
    url: `/buy/cash?code=${CashChargeCode.Start}&returnUrl=${encodeURIComponent(
      returnUrl
    )}${chargeAmount ? `&chargeAmount=${chargeAmount}` : ''}`,
    target: 'cashcharge',
    features: 'width=500, height=680',
    blockPopupText:
      '만약 팝업 차단 기능을 해제하지 않으면 정상적인 충전이 이루어지지 않습니다.',
  });
}
